import { render, staticRenderFns } from "./CookiesModal.vue?vue&type=template&id=e5324044&scoped=true&"
import script from "./CookiesModal.vue?vue&type=script&lang=js&"
export * from "./CookiesModal.vue?vue&type=script&lang=js&"
import style0 from "./CookiesModal.vue?vue&type=style&index=0&id=e5324044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5324044",
  null
  
)

export default component.exports